export type HowItWorksItem = {
  title: string;
  description: string;
  image: string;
};

export const HOW_IT_WORKS_ITEMS: HowItWorksItem[] = [
  {
    title: 'Install the Path tool on your computer.',
    description:
      'Download and install Path on your computer. Our intuitive tool will guide you through the setup process.',
    image: 'desktop2.svg',
  },
  {
    title: 'Complete surveys so Path can understand you.',
    description: `You'll share your skills, interests, and goals, allowing us to provide you with a customized experience and relevant recommendations.`,
    image: 'checklist2.svg',
  },
  {
    title: 'Receive Personalized Insights & Opportunities',
    description: `Path analyzes your input to offer career insights and unique monetization opportunities, aligning with your skills and objectives—even beyond Go2.`,
    image: 'bulb2.svg',
  },
  {
    title: 'Track your progress, grow your career.',
    description: `You’ll be able to see how your skills and interests evolve, and use this information to make informed decisions about your career.`,
    image: 'insights2.svg',
  },
];
